export const environment = {
  keycloak: {
    url: 'https://auth.sandbox.eudi-wallet.org',
    realm: 'sandbox-registrar',
    clientId: 'swagger',
  },
  api: 'http://localhost:3001',
  grafanaUrl: 'http://localhost:3002/d/279d981c-e4e8-40e9-a29a-dfa6c383f6b5',
  // Grafana Faro collector for browser errors; empty disables reporting
  faroUrl: '',
  production: false,
};
